<template>
  <div class="main-content-container overflow-hidden">
    <ListItem />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ListItem from "@/components/Pages/Management/Item/ListItem.vue";

export default defineComponent({
  name: "ListItemPage",
  components: {
    ListItem,
  },
});
</script>
